import { AxiosRequestConfig } from "axios"
import { BaseEndpoint } from "../base.endpoint"
import {
  MailchimpStoreInputAttributes,
  MailchimpStoreAttributes,
  MailchimpProductInputAttributes,
  MailchimpProductAttributes,
} from "../../types/attributes"
import { Params } from "../../types/request"

export class Automation extends BaseEndpoint {
  public async createMailchimpStore(
    body: MailchimpStoreInputAttributes,
    params: Params = {}
  ): Promise<MailchimpStoreAttributes> {
    const { data } = await this.http.post(
      this.routes.automationMailchimpCreateStorePath(),
      {
        currency_code: body.currency_code,
        domain: body.domain,
        email_address: body.email_address,
        id: String(body.id),
        list_id: body.list_id,
        name: body.name,
      },
      { params } as AxiosRequestConfig
    )
    return data
  }

  public async deleteMailchimpStore(
    params: Params = {}
  ): Promise<MailchimpStoreAttributes> {
    const { data } = await this.http.delete(
      this.routes.automationMailchimpDeleteStorePath(),
      { params } as AxiosRequestConfig
    )
    return data
  }

  public async createMailchimpProduct(
    body: MailchimpProductInputAttributes,
    params: Params = {}
  ): Promise<MailchimpProductAttributes> {
    const { data } = await this.http.post(
      this.routes.automationMailchimpCreateProductPath(),
      body,
      { params } as AxiosRequestConfig
    )

    return data
  }
}
